import React, { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { useLocation } from 'react-router'
import Empty from '@components/empty'
import userStore from '@src/store/common/user'

interface PrivateRouteProps {
	children: React.ReactNode
}

const PrivateRoute: FC<PrivateRouteProps> = ({ children }) => {
	const location = useLocation()
	const { pathname } = location
	const logged = userStore((state) => state.token !== '')

	if (!logged) {
		// 未登录
		if (pathname === '/' || pathname === '/login') {
			return <Navigate to="/login" replace />
		}
		return <Empty title="没有权限" description="您还没有登录，请先去登录" type="403" />
	}

	// 已登录
	if (pathname === '/') {
		return <Navigate to="/dashboard/workbench" replace />
	}

	return <>{children}</>
}

export default PrivateRoute
